import { Col } from 'antd'

export default Col


// WEBPACK FOOTER //
// ./src/wbap-components/col/index.js